import { memo, useCallback, useEffect, useState } from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  Loading,
  Modal,
  RadioGroupInput,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";

import { TAppointment } from "../schema";
import { IInsuranceFavorite } from "../../../NewSchedule/Insurance/model";
import { ScheduleInsuranceService } from "../../../NewSchedule/Insurance/insurance.service";
import InsuranceForm from "../../../NewSchedule/Insurance/AddInsurance/InsuranceForm";

const Insurance = () => {
  const [insurances, setInsurances] = useState<IInsuranceFavorite[]>([]);

  const [open, setOpen] = useState(false);

  const { getValues } = useFormContext<TAppointment>();

  const { patient } = getValues();

  const { t } = useTranslation();

  const { sendRequest, loading } = useFetch(ScheduleInsuranceService.list);

  const fetch = useCallback(async () => {
    if (!patient.id) return;

    const { data, success } = await sendRequest({
      IndividualId: patient.id,
    });

    if (data && success) {
      setInsurances(data);
    }
  }, [sendRequest, patient]);

  const onClickHandler = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSuccess = () => {
    handleClose();
    fetch();
  };

  useEffect(() => {
    fetch();
  }, [fetch]);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Typography variant="h5">
          {t("components.scheduleAssistant.newSchedule.insurance")}
        </Typography>
        <InsuranceForm onSuccess={handleSuccess} patient={patient} />
      </Modal>
      <Stack gap={1}>
        <RadioGroupInput
          name="insurance"
          groupLabel={t("components.scheduleAssistant.newSchedule.insurance")}
          valueField="id"
          disableBorder
          radios={insurances.map((i) => ({
            label: i.insuranceName,
            value: { name: i.insuranceName, id: i.code },
          }))}
        />
        <Stack
          alignItems={"center"}
          direction={"row"}
          onClick={onClickHandler}
          gap={1}
          sx={{
            cursor: "pointer",
            "&:hover": {
              opacity: 0.7,
            },
          }}
        >
          <AddCircleOutlineIcon color="inherit" fontSize="small" />
          <Typography>
            {t("components.scheduleAssistant.newSchedule.addInsurance")}
          </Typography>
        </Stack>
      </Stack>
    </>
  );
};

export default memo(Insurance);
